export enum DrawingItemTypeEnum {
  ImageEdit = 0,
  Drawing = 1,
  Arrow = 2,
  Tag = 3,
  Line = 4,
  Text = 5,
  DrawingArrowLine = 6,
  Circle = 7,
}
